import { render, staticRenderFns } from "./ChatSelector.vue?vue&type=template&id=70ccaa8b&scoped=true"
import script from "./ChatSelector.vue?vue&type=script&lang=js"
export * from "./ChatSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatSelector.vue?vue&type=style&index=0&id=70ccaa8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccaa8b",
  null
  
)

export default component.exports